

export default {
    name: 'MeatPageButton',
    props: {
        to: {
            type: [String, Object],
            default: null
        },
        href: {
            type: String,
            default: ""
        },
        mobileHref: {
            type: String,
            default: ""
        },
        textClass: {
            type: String,
            default: ""
        },
        variant: {
            type: String,
            default: "color"
        }
    },
    data() {
        return {
            isMobile: false
        }
    },
    computed: {
        currentHref() {
            if (this.isMobile && this.mobileHref) {
                return this.mobileHref
            }
            return this.href
        },
        componentType() {
            if (this.to && !(this.isMobile && this.mobileHref)) {
                return 'NuxtLink'
            }
            return this.currentHref ? 'a' : 'button'
        }
    },
    mounted() {
        this.checkScreenSize()
        window.addEventListener('resize', this.checkScreenSize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize)
    },
    methods: {
        checkScreenSize() {
            this.isMobile = window.innerWidth <= 1024
        }
    }
}
